export default "__VITE_ASSET__Ta5Vf8tV__"